import {isDonationTicketDefinition} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {useAppSelector} from '../../../../../hooks/runtime'
import {getEvent} from '../../../../../selectors/event'
import {getTax} from '../../../../../selectors/tax-and-fee'
import {a11yTaxId} from '../../a11y'
import {classes} from './tax.st.css'

export interface TaxProps {
  ticket: wix.events.ticketing.TicketDefinition
  className?: string
  overridePrice?: string
}

export const Tax = ({ticket, className, overridePrice}: TaxProps) => {
  const {t} = useTranslation()
  const event = useAppSelector(getEvent)
  const abstract = isDonationTicketDefinition(ticket) && !overridePrice
  const {getFormattedMoney} = useCurrencyFormatter()
  const tax = getTax({event, ticket, t, overridePrice, abstract, getFormattedMoney})

  if (!tax) {
    return null
  }

  return (
    <Text id={a11yTaxId(ticket.id)} tagName="p" className={classNames(classes.tax, className)} data-hook={DH.TAX_LABEL}>
      {tax}
    </Text>
  )
}
